/**
 * GraphQL schema definition that only exists on the client.
 * Defines fields that can be resolved on the client and never reach the servers.
 *
 * Schema definitions are composable.
 * To convert a schema definition into a schema, use `buildAstFromSchema`.
 */
import {mergeTypeDefs} from '@graphql-tools/merge';

import ClientDirective from 'graphql-client/ClientDirective.graphql';
import MolBioTypeDefs from 'graphql-client/MolBioTypeDefs.graphql';

const GraphQLClientSchemaDef = mergeTypeDefs([ClientDirective, MolBioTypeDefs]);
export default GraphQLClientSchemaDef;
